import type { ReduxSelector } from 'store/store.types';
import { BANNER_SLICE_NAME } from 'store/slices/slicesNames';
import type { BannerSliceState } from './banner.types';

/** True if the banner should be shown */
export const showBanner: ReduxSelector<boolean> = (state) => state[BANNER_SLICE_NAME].showBanner;

export const variant: ReduxSelector<BannerSliceState['variant']> = (state) =>
  state[BANNER_SLICE_NAME].variant;
export const text: ReduxSelector<string> = (state) => state[BANNER_SLICE_NAME].text;
export const color: ReduxSelector<string | undefined> = (state) => state[BANNER_SLICE_NAME].color;
export const hasDismissed: ReduxSelector<boolean> = (state) =>
  state[BANNER_SLICE_NAME].hasDismissed;
export const styleVariant: ReduxSelector<BannerSliceState['styleVariant']> = (state) =>
  state[BANNER_SLICE_NAME].styleVariant;
export const icon: ReduxSelector<BannerSliceState['icon']> = (state) =>
  state[BANNER_SLICE_NAME].icon;
